export default __webpack_public_path__ + "static/media/flv8.58221852.jpeg";